import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Play } from '../assets/js/svg/gui';

// Shared launch button (Play icon + label) for the popup title bar and the guide's inline tuto links.
const TutorialLaunchButton = function TutorialLaunchButton({ label, onClick, className }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        'inline-flex flex-row items-center gap-1 shrink-0 align-middle rounded border border-pxPrimary bg-white text-pxPrimary text-sm font-medium px-2 py-1 cursor-pointer hover:bg-pxPrimary/10',
        className,
      )}
    >
      <Play className="h-3.5 w-3.5 shrink-0 fill-pxPrimary" />
      {label}
    </button>
  );
};

TutorialLaunchButton.propTypes = {
  label: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default TutorialLaunchButton;
